import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class TransloadOrders_ds_transload_composites_by_transload_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { transload_id: number, excluded_shipment_id?: number }): 
  Promise<{ result: { LicensePlateId?: number, Shipmentid?: number, Shipment?: { Id?: number, LookupCode?: string }, LicensePlate?: { TypeId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.transload_id)) {
      missingRequiredInParams.push('\'transload_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { transload_id: number, excluded_shipment_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { LicensePlateId?: number, Shipmentid?: number, Shipment?: { Id?: number, LookupCode?: string }, LicensePlate?: { TypeId?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.transload_id)) {
      missingRequiredInParams.push('\'transload_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { transload_id: number, excluded_shipment_id?: number, $keys: { LicensePlateId?: number, Shipmentid?: number }[] }): 
  Promise<{ result: { LicensePlateId?: number, Shipmentid?: number, Shipment?: { Id?: number, LookupCode?: string }, LicensePlate?: { TypeId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.transload_id)) {
      missingRequiredInParams.push('\'transload_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      transload_id: number, excluded_shipment_id?: number    }) {
        if(isNil(inParams.transload_id)) {
          return true; 
        }
      return false;
    }
}
